import React, { useState, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css'; // Bootstrap importálása
import './Filter.css'; // Stílus hozzáadás
import Paginator from '../../Paginator/Paginator';
import { Collapse, Select } from 'antd'; // Ant Design használata
import Filter from './Filter'; // Importáld a filter komponenst

const apiUrl = process.env.REACT_APP_API_URL;

const { Panel } = Collapse; // Ant Design Collapse Panel
const { Option } = Select; // Ant Design Select Option


const FilterContainer = ({
  onFilter,
  onPageSizeChange,
  onColumnsChange,
  onSortChange,
  currentPage,
  pageSize,
  sortOrder,
  columns,
  totalItems,
  onPageChange,
  categories: propCategories, // Rename to avoid conflict with internal state
}) => {
  const [name, setName] = useState('');
  const [category, setCategory] = useState('');
  const [uploadDateStart, setUploadDateStart] = useState('');
  const [uploadDateEnd, setUploadDateEnd] = useState('');
  const [creationDateStart, setCreationDateStart] = useState('');
  const [creationDateEnd, setCreationDateEnd] = useState('');
  const [categories, setCategories] = useState([]);
  const [token] = useState(localStorage.getItem('token') || '');

  useEffect(() => {
    if (propCategories && propCategories.length > 0) {
      setCategories(propCategories);
    } else {
      fetch(`${apiUrl}/categories`, {
        headers: {
          'Authorization': `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((data) => setCategories(data));
    }
  }, [token, propCategories]);

  const handleFilterSubmit = (filterParams) => {
    onFilter(filterParams);
  };

  return (
    <div>
      <Collapse className='mb-3'>
        <Panel header="Filter" key="filter" >
          <Filter onFilter={handleFilterSubmit} categories={categories} />
        </Panel>
      </Collapse>
      <div className="media-controls-container"> {/* New container for controls */}
        <div className="media-control-item">
          <Select
            value={pageSize}
            onChange={onPageSizeChange}
            placeholder="Képek száma az oldalon"
            style={{ marginLeft: '10px' }}
          >
            <Option value={1}>1</Option>
            <Option value={5}>5</Option>
            <Option value={10}>10</Option>
            <Option value={20}>20</Option>

          </Select>
        </div>
        <div className="media-control-item">
          <Select
            value={columns}
            onChange={onColumnsChange}
            placeholder="Oszlopok száma"
            style={{ marginLeft: '10px' }}
          >
            <Option value={2}>2 oszlop</Option>
            <Option value={3}>3 oszlop</Option>
            <Option value={4}>4 oszlop</Option>
            <Option value={5}>5 oszlop</Option>
            <Option value={6}>6 oszlop</Option>
          </Select>
        </div>
        <div className="media-control-item">
          <Select
            value={sortOrder}
            onChange={onSortChange}
            style={{ marginLeft: '10px' }}
            placeholder="Rendezési mód"
          >
            <Option value="newest">Legújabb elől</Option>
            <Option value="oldest">Legrégebbi elől</Option>
            <Option value="name">Név szerint</Option>
            <Option value="category">Kategória szerint</Option>
          </Select>
        </div>
        <div className="media-control-item paginator-container">
          <Paginator
            currentPage={currentPage}
            totalItems={totalItems}
            pageSize={pageSize}
            onPageChange={onPageChange}
            style={{ marginLeft: '10px' }}
          />
        </div>

      </div>
    </div>
  );
};

export default FilterContainer;
